import React from 'react'
import ReactDOM from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import '@fontsource-variable/geist'
import App from './App.jsx'
import { APP_SURFACES, getAppSurface } from '@config/appSurface'
import { INTERNAL_BRAND, PORTAL_BRAND } from '@config/brand'
import '@fortawesome/fontawesome-free/css/all.min.css'
import './styles/app.css'
import './styles/portalThemes.css'
import './styles/portalLayout.css'
import './styles/internalLayout.css'
import './styles/portalPolish.css'
import './styles/voileInternal.css'
import './styles/portalInternal.css'
import './styles/portalLogin.css'

const activeBrand = getAppSurface() === APP_SURFACES.CLIENT_PORTAL ? PORTAL_BRAND : INTERNAL_BRAND
document.querySelector('#app-favicon')?.setAttribute('href', activeBrand.faviconPath)

// A data router lets editors pause navigation while unsaved changes are reviewed.
const router = createBrowserRouter([{ path: '*', element: <App /> }])

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
)
